exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#alerts{position:fixed;z-index:20;top:0;left:0;width:100%}#alerts .alert .close,#alerts .alert .message{padding-top:15px;padding-bottom:15px;font-size:12px}#alerts .alert.info{color:#004085;background-color:#cce5ff;border-color:#b8daff}#alerts .alert.success{color:#155724;background-color:#d4edda;border-color:#c3e6cb}#alerts .alert.error{color:#721c24;background-color:#f8d7da;border-color:#f5c6cb}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b46b9cba","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Alerts.vue
// module id = 384
// module chunks = 0